import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiEndpoint } from 'config';
import { axiosBaseQuery } from 'lib/axios/baseAxios';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  // @ts-ignore
  baseQuery: axiosBaseQuery({
    baseUrl: baseApiEndpoint,
  }),
  endpoints: () => ({}),
  keepUnusedDataFor: 10,
});
